import { tr } from '@/lib/i18n-core';
import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import { Alert } from '@/components/ui/primitives';

export function DoctorsWithoutFeeAlert() {
  const uncovered = useQuery({
    queryKey: ['consultation-fees', 'doctors-without-fee'],
    queryFn: () => get<{ id: string; name: string }[]>('/consultation-fees/doctors-without-fee'),
  });
  if (!uncovered.data || uncovered.data.length === 0) return null;
  return (
    <Alert variant="warning">
      {tr('billing', 'no_consultation_fee_is_set_for')} {uncovered.data.map((doctor) => doctor.name).join(', ')}
      {tr('billing', 'their_visits_will_show_no_fee_set_until_added_to_a_service')}
    </Alert>
  );
}
